import Modal from "src/components/common/modal"
//---------------------------------------------------------------------
export default function MainReplyForm({
    closeIt,
    keyword,
    body,
    handleSubmit
}){
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"900px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div>
                <div className = "my-2" style = {{display:"flex"}}>
                    <span className = "font-weight-bold mr-3">Body:</span>
                    <textarea required className = "form-control" style = {{flexGrow: 1}} name = "body" defaultValue = {body || ""}/>
                </div>
            </div>
        </Modal>
    )
}
